function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.5 25C19.4036 25 25 19.4036 25 12.5C25 5.59644 19.4036 0 12.5 0C5.59644 0 0 5.59644 0 12.5C0 19.4036 5.59644 25 12.5 25Z",
  fill: "url(#paint0_linear)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M16.9576 7.63689C17.3455 8.14047 17.5179 8.76993 17.5179 9.48333C17.5179 10.2387 17.3455 10.8262 16.9576 11.2878C16.7422 11.5396 16.4405 11.7914 16.0096 12.0012C16.656 12.211 17.13 12.5887 17.4748 13.0923C17.8195 13.5959 17.9488 14.1834 17.9488 14.8968C17.9488 15.6102 17.7764 16.2816 17.3886 16.8271C17.1731 17.2048 16.8714 17.5405 16.4836 17.7923C16.0957 18.0861 15.6217 18.2959 15.0615 18.4218C14.5013 18.5477 13.941 18.5896 13.2946 18.5896H7.69238V6.41992H13.7256C15.277 6.33599 16.3543 6.7976 16.9576 7.63689ZM10.1918 8.43422V11.1199H13.2515C13.8118 11.1199 14.2427 11.036 14.5874 10.8262C14.9322 10.6164 15.1046 10.2807 15.1046 9.77708C15.1046 9.18958 14.8891 8.85386 14.4151 8.64404C14.0272 8.51815 13.5532 8.43422 12.9499 8.43422H10.1918ZM10.1918 13.1342V16.3655H13.2084C13.7687 16.3655 14.1565 16.2816 14.4582 16.1557C15.0184 15.9039 15.277 15.4003 15.277 14.645C15.277 14.0155 15.0184 13.5959 14.5013 13.3441C14.1996 13.2182 13.7687 13.1342 13.2515 13.1342H10.1918Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 0,
  y1: 12.5,
  x2: 25,
  y2: 12.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C79081"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.635417,
  stopColor: "#DFA579"
})));

function SvgBronze(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBronze);
export default __webpack_public_path__ + "static/media/bronze.315ed5cc.svg";
export { ForwardRef as ReactComponent };